import React, { useMemo } from 'react';
import { testId } from '../../../../utils/testIds';
import { useFormContext } from 'react-hook-form';
import AsyncSearchSelect from '../AsyncSearchSelect';
import { useAddressSiblings } from '../utils/addressKeys';
import { getSectionFromKey, getAddressPlaceholder } from '../utils/addressLabels';
import { useStates } from '../../../../containers/CreationForms/AddEditWorkkard/hooks/useStates';

function StateAsyncField({ config, value, onChange, onBlur, disabled, required, error }) {
  const { watch } = useFormContext();

  const section = useMemo(() => getSectionFromKey(config.fieldKey), [config.fieldKey]);
  const { countryKey } = useAddressSiblings(config.fieldKey);

  const country = watch(countryKey);

  const placeholder = useMemo(
    () => config?.fieldSettings?.placeholder || getAddressPlaceholder({ role: 'state', section }),
    [config, section]
  );

  const { states: preloadedStates } = useStates(section, country);

  const fetchOptions = useMemo(() => {
    if (!country) return null;
    return async (q) => {
      const query = String(q || '').toLowerCase();
      if (!query) return preloadedStates;
      return preloadedStates.filter(
        (o) =>
          String(o.label).toLowerCase().includes(query) ||
          String(o.value).toLowerCase().includes(query),
      );
    };
  }, [country, preloadedStates]);

  if (!country) {
    return (
      <input
        data-test={testId('field', config.fieldKey, 'input')}
        type="text"
        className="field-engine-input disabled"
        value=""
        disabled
        placeholder={placeholder}
        title="Select a country first"
      />
    );
  }

  return (
    <AsyncSearchSelect
      config={config}
      value={value}
      onChange={onChange}
      onBlur={onBlur}
      disabled={disabled}
      required={required}
      error={error}
      fetchOptions={fetchOptions}
      placeholder={placeholder}
      minChars={0}
      debounceMs={0}
      preloadedOptions={preloadedStates}
    />
  );
}

export default StateAsyncField;
